var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeter1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.429,
    height: 12,
    viewBox: "0 0 15.429 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-tachometer-alt",
    "data-name": "Icon awesome-tachometer-alt",
    d: "M7.714,2.25A7.714,7.714,0,0,0,1.046,13.843a.848.848,0,0,0,.735.407H13.647a.848.848,0,0,0,.735-.407A7.714,7.714,0,0,0,7.714,2.25Zm0,1.714a.846.846,0,0,1,.812.633,1.444,1.444,0,0,0-.092.179l-.247.741a.835.835,0,0,1-.473.161.857.857,0,0,1,0-1.714ZM2.571,11.679a.857.857,0,1,1,.857-.857A.857.857,0,0,1,2.571,11.679ZM3.857,7.393a.857.857,0,1,1,.857-.857A.857.857,0,0,1,3.857,7.393Zm6.61-1.94L8.824,10.382a1.682,1.682,0,0,1,.366,2.154H6.238A1.7,1.7,0,0,1,7.6,9.975L9.247,5.046a.643.643,0,0,1,1.22.407Zm.393,1.532.416-1.247a.845.845,0,0,1,.3-.06.857.857,0,1,1,0,1.714.844.844,0,0,1-.712-.408Zm2,4.693a.857.857,0,1,1,.857-.857A.857.857,0,0,1,12.857,11.679Z",
    transform: "translate(0 -2.25)",
    fill: "#72FF13"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter1);
export default __webpack_public_path__ + "static/media/meter1.f5a9ae6fd6d6bfaab8a0e716a987b39b.svg";
export { ForwardRef as ReactComponent };